
    <ng-container *ngIf="legends$ | async as legends">
      <div
        *ngIf="legends | filled"
        class="container-fluid"
      >
        <div
          fieldmagicGridRow
          class="w-100"
        >
          <ng-container *ngFor="let legend of legends; trackBy: tracker; let index = index;">
            <div
              [fieldmagicGridColumn]="legends.length > 12 ? 3 : 2"
              class="fieldmagic-legend-container pointer pl-0 pr-0 pb-0 pt-0"
              [class.pr-1]="legends.length > 1 && index !== (legends.length - 1)"
              (click)="onClick(legend)"
            >
              <div
                class="w-100 rounded h-30"
                [style.background-color]="legend.color"
                [style.color]="legend.text_color"
              >
                <div class="h-100">
                  <div class="row ml-0 mr-0">
                    <div
                      class="col-xl-3 col-lg-3 col-md-12 col-sm-3 col-xs-3 col-3 fieldmagic-legend-count text-center border-right border-white"
                      [style.color]="legend.text_color"
                    >
                      {{ legend.count | fallback : legend.default_count }}
                    </div>

                    <div
                      class="col-xl-9 col-lg-9 col-md-12 col-sm-9 col-xs-9 col-9 fieldmagic-legend-text text-center border-white"
                      [style.color]="legend.text_color"
                    >
                      {{ legend.label | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  